import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { DirectsState, GetDirects, RoleGuard, UserState } from '@coin/shared/auth/feature';
import { filter, map, Observable, of, switchMap, take } from 'rxjs';

/**
 * @deprecated please use {@link canActivateRoleGuard}
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerRoleGuard extends RoleGuard {
  private userState = inject(UserState);

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(UserState.user).pipe(
      filter(Boolean),
      switchMap(user => this.store.dispatch(new GetDirects({ userId: user.id }))),
      map(() => this.directAllowedAccess(route)),
      switchMap(canActivate => (canActivate ? of(true) : super.canActivate(route)))
    );
  }

  private directAllowedAccess(route: ActivatedRouteSnapshot): boolean {
    return (
      !!(
        route.data?.directAllowAccessHead &&
        this.userState.currentUserDetails$.pipe(
          take(1),
          map(userDetails => userDetails?.isHead)
        )
      ) || !!(route.data?.directAllowAccessLineManager && this.store.selectSnapshot(DirectsState.isLineManager))
    );
  }
}
